<template>
	<div id="app">
		<!-- 组件使用 -->
		<syalert ref="syalert_id" />
		
		<router-view v-if='!$route.meta.keepAlive'></router-view>
		<keep-alive>
			<router-view v-if='$route.meta.keepAlive'></router-view>
		</keep-alive>


	
	</div>



</template>
<script>
	import sy from "@/sy";

	// ---------- 引入组件
	import syalert from '@/components/syalert.vue';

	export default {
		name: "App",
		// created
		// beforeCreate
		components: {
			syalert,
		},
		created()
		{
			sy.log('[App]-> App init');
			sy.log('[App]-> ' + location.href);		// 域名 + 路径
			sy.log('[App]-> ' + location.pathname); // 路径
			sy.log('[Bug]-> ' + location.origin + '/bugs/sys'); // Bug

			// 设置 qdcode 预埋入口 覆盖写入
			// let qdcode = sy.http.getSearch('qdcode');
			// sy.log(qdcode);

			// 免登规则 可以免签
			let auth_skip = false;
			let auth_list =
			[
				'/',
				'/sys',
				'/index',
				'/auth/login',
				'/auth/phone',
				'/auth/wechat',

				'/goods',
				'/order/cashpay',
				'/order/cashkefu',
				'/order/cashnotify',
			];
			for (let x of auth_list)
			{
				if( location.pathname === x )
				{
					auth_skip = true;
					console.log('免登页面: ' + x);
				}
			}

			// 首次载入检查 跳至登陆页 载入后只能靠异步401
			// 异步网络请求401 sy.http.get 已经独立处理
			// console.log(localStorage.getItem("utoken"));
			if ( auth_skip === false && localStorage.getItem("utoken") === null )
			{
				if( sy.http.is_wechat() )
				{
					// console.log(sy.http.is_wechat());
					// 跳去登录页 + 带参（当前页面地址） 微信模式 ?????
					let Base64 = require("js-base64").Base64;
					let pageto = Base64.encode(location.href);
					this.$router.push("/auth/wechat?pageto=" + pageto);
				}else{
					// 跳去手机登录页 
					this.$router.push('/auth/login');
					// 需要挂载后才能操作组件
					// this.$refs.syalert_id.syalert('res.msg', 1000, function()
					// {
					// });
				}
			}
		},
		mounted()
		{
		},
		methods: {},
	};
</script>